var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.onClick}},[_c('img',{staticClass:"photo",style:(_vm.getPhotoStyle),attrs:{"onerror":_vm.defaultImage,"src":_vm.getPhotoUrl}}),_vm._v(" "),_c('label',{ref:"title",staticClass:"title",staticStyle:{"-webkit-box-orient":"vertical"}},[_vm._v(_vm._s(_vm.getTitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd91478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/cardpage/card/CardZ1.vue
// module id = null
// module chunks = 